import React, { useState } from 'react';
import axios from 'axios';
import { FaTimes } from 'react-icons/fa';
import './SpeakToExpert.css';
import expertBg from '../../assets/expert-bg.jpg'; 

// Added prop 'isModal' (default is false)
const SpeakToExpert = ({ onClose, isModal = false }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', phone: '',
    jobTitle: '', company: '', commodity: '', country: ''
  });
  const [errors, setErrors] = useState({});

  const commodities = [
    "Grains", "Spices", "Sugar", "Pulses", 
    "Vegetables", "Oilseeds"
  ];
  
  const countries = [
    "Asia", "Europe", "Australia", "North-America", "South-America", "Africa"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: '' });
  };

  const validate = () => {
     let newErrors = {};
     // (Validation logic same as before)
     if(step===1){
         if(!formData.firstName) newErrors.firstName="Required";
         if(!formData.lastName) newErrors.lastName="Required";
         if(!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) newErrors.email="Invalid Email";
         if(!formData.phone || !/^[0-9]+$/.test(formData.phone)) newErrors.phone="Numbers only";
     }
     if(step===2){
         if(!formData.jobTitle) newErrors.jobTitle="Required";
         if(!formData.company) newErrors.company="Required";
     }
     if(step===3){
         if(!formData.commodity) newErrors.commodity="Required";
         if(!formData.country) newErrors.country="Required";
     }
     setErrors(newErrors);
     return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (validate()) {
      if (step < 3) {
        setStep(step + 1);
      } else {
        try {
            const response = await axios.post('http://127.0.0.1:5000/api/inquire', formData);
            if (response.status === 201) {
                alert("Thank you! Your inquiry has been sent to our experts.");
                // Only close if it's a modal
                if (isModal && onClose) onClose();
                else setStep(1); // Reset if on homepage
            }
        } catch (error) {
            alert("Submission failed. Please try again.");
        }
      }
    }
  };

  // EXTRACTED THE CORE CONTENT
  const formContent = (
    <section id="speak-to-expert-section" className="expert-section" style={{ backgroundImage: `url(${expertBg})` }}>
      <div className="expert-overlay">
        <div className="container expert-container">
          <div className="expert-content">
            <h2>Speak to our experts today</h2>
            <p>Register below and we will customise a solution that meets your exact needs.</p>

            <form className="expert-form">
              {step === 1 && (
                <div className="form-step fade-in">
                  <div className="form-row">
                    <div className="input-group"><input name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name" className={`form-input ${errors.firstName ? 'error-border' : ''}`} /></div>
                    <div className="input-group"><input name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name" className={`form-input ${errors.lastName ? 'error-border' : ''}`} /></div>
                  </div>
                  <div className="form-row">
                    <div className="input-group"><input name="email" value={formData.email} onChange={handleChange} placeholder="Email" className={`form-input ${errors.email ? 'error-border' : ''}`} /></div>
                    <div className="input-group"><input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone" className={`form-input ${errors.phone ? 'error-border' : ''}`} /></div>
                  </div>
                </div>
              )}
              {step === 2 && (
                <div className="form-step fade-in">
                  <div className="form-row">
                    <div className="input-group"><input name="jobTitle" value={formData.jobTitle} onChange={handleChange} placeholder="Job Title" className={`form-input ${errors.jobTitle ? 'error-border' : ''}`} /></div>
                    <div className="input-group"><input name="company" value={formData.company} onChange={handleChange} placeholder="Company" className={`form-input ${errors.company ? 'error-border' : ''}`} /></div>
                  </div>
                </div>
              )}
              {step === 3 && (
                <div className="form-step fade-in">
                  <div className="form-row">
                     <div className="input-group">
                        <select name="commodity" value={formData.commodity} onChange={handleChange} className={`form-input form-select ${errors.commodity ? 'error-border' : ''}`}>
                            <option value="">Select Commodity</option>
                            {commodities.map((c,i)=><option key={i} value={c}>{c}</option>)}
                        </select>
                     </div>
                     <div className="input-group">
                        <select name="country" value={formData.country} onChange={handleChange} className={`form-input form-select ${errors.country ? 'error-border' : ''}`}>
                            <option value="">Select Region</option>
                            {countries.map((c,i)=><option key={i} value={c}>{c}</option>)}
                        </select>
                     </div>
                  </div>
                </div>
              )}
              
              <button type="button" className="btn-next" onClick={handleNext}>
                {step === 3 ? 'Submit' : 'Next'}
              </button>
            </form>
            
            <div className="progress-indicators">
                <div className={`bar ${step >= 1 ? 'active' : ''}`}></div>
                <div className={`bar ${step >= 2 ? 'active' : ''}`}></div>
                <div className={`bar ${step >= 3 ? 'active' : ''}`}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  // LOGIC TO SWITCH BETWEEN MODAL AND INLINE
  if (isModal) {
      return (
        <div className="modal-backdrop">
            <div className="modal-container">
                <button className="btn-close" onClick={onClose}>
                    <FaTimes size={24} />
                </button>
                {formContent}
            </div>
        </div>
      );
  }

  // If not modal, just return the content directly
  return formContent;
};

export default SpeakToExpert;